import React, { Fragment, useEffect, useState, useRef } from "react";

import { Modal, ModalBody, ModalHeader, Input, Label } from "reactstrap";
import { useForm, Controller } from "react-hook-form";
///import { Editor } from 'react-draft-wysiwyg';
//import draftToHtml from 'draftjs-to-html';
import cx from "classnames";
// import {
//     ContentState,
//     convertToRaw,
//     EditorState,
//     RichUtils
// } from 'draft-js';
//import htmlToDraft from 'html-to-draftjs';
import {
    replaceHtmlToString,
    showToast,
    //htmlToDraftBlocks,
    decodeHtmlEntities,
    confirmBox,
    getFieldsByFormname,
    addTableBorder,
    normalizeTemplateVariables
} from "../../../Common/Appcommon";
import requestApi from "../../../services/requestApi.service";
import CratioMention from "../../Common/CratioMention";
import CommonHeaderContent from "../../../Common/CommonHeaderContent";
import CustomToolBarOption from "../../Common/CratioToolbarButtons";
//import {    toggleCustomInlineStyle, getSelectionCustomInlineStyle,} from 'draftjs-utils';
import { ModalFooter } from "react-bootstrap";
import CKEditorComponent from "../../../Common/CKEditor/CKEditorComponent";

const TemplateOperation = ({
    isMainModal,
    toggleMainMadal,
    selectedForm,
    formid,
    type,
    loadData,
    formList,
    orgFormName,
}) => {
    const buttonClickRef = useRef(null);
    const { control, handleSubmit, formState: { errors } } = useForm();
    const [formData, setFormData] = useState([]);
    const [fieldsOption, setFieldsOption] = useState([]);
   // const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [templateContent, setTemplateContent] = useState("");
    const [msgString, setMsgString] = useState("");
    const [isNormalEditor, setIsNormalEditor] = useState(type === "sms");
    const [isHtmlView, setIsHtmlView] = useState(false);
    const [isPreView, setIsPreView] = useState(false);
    const [messageBoxRequired, setMessageBoxRequired] = useState(false);
    const [newSelectedForm, setNewSelectedForm] = useState([]);
    
    useEffect(() => {
        (async () => {
            let selectedformname = [];
            if (formid !== "") {
                let formdata = await prepareEditInfo(formid);
                const formname = formdata['formname'];
                selectedformname = formList.find(obj => obj.value === formname);
            } else {
                selectedformname = selectedForm;
                setFormData([]);
            }
            setNewSelectedForm(selectedformname)
            let selectedfields = await getFieldsByFormname(selectedformname.value, "crm_template_operation");
            //let orgfields = await getFieldsByFormname(orgFormName, "organization");
            //const mergedArray = [...selectedfields, ...orgfields.filter(obj2 => !selectedfields.some(obj1 => obj1.value === obj2.value))];
            setFieldsOption(selectedfields);
        })();
    }, []);

    // function setDefaultFontSizeAndStyle(editorState, defaultSize = '10px', defaultStyle = 'Arial') {
    //     let newEditorState = editorState;

    //     // Check if the current font size is set
    //     const currentFontSize = getSelectionCustomInlineStyle(editorState, ['FONTSIZE']).FONTSIZE;
    //     if (!currentFontSize) {
    //         newEditorState = RichUtils.toggleInlineStyle(newEditorState, `fontSize-${defaultSize}`);
    //     }

    //     // Check if the current font family is set
    //     const currentFontStyle = getSelectionCustomInlineStyle(editorState, ['FONTFAMILY']).FONTFAMILY;
    //     if (!currentFontStyle) {
    //         newEditorState = RichUtils.toggleInlineStyle(newEditorState, `fontFamily-${defaultStyle}`);
    //     }

    //     return newEditorState;
    // }

    // function setDefaultFontStyle(editorState, style = 'Arial') {
    //     const currentFontStyle = getSelectionCustomInlineStyle(editorState, ['FONTFAMILY']).FONTFAMILY;
    //     let newEditorState = editorState;
    //     if (!currentFontStyle) {
    //         newEditorState = toggleCustomInlineStyle(newEditorState, 'fontFamily', style);
    //     }
    //     return newEditorState;
    // }

    // function setDefaultFontSize(editorState, size = 10) {
    //     const currentFontSize = getSelectionCustomInlineStyle(editorState, ['FONTSIZE']).FONTSIZE;
    //     let newEditorState = editorState;
    //     if (!currentFontSize) {
    //         newEditorState = toggleCustomInlineStyle(newEditorState, 'fontSize', size);
    //     }
    //     return newEditorState;
    // }

    const prepareEditInfo = async (formid) => {
        let formdata = [];

        if (formid === "") {
            return;
        }
        let params = {
            "ENTITY": "TEMPLATEHELPER",
            "OPERATION": "GET_CRM_TEMPLATES",
            "FORMID": formid,
            "METHOD": "GET",
            "MODULENAME": "",
            "channel": type == "sms" ? "SMS" : "EMAIL",
        };
        let response = await requestApi.processServerRequest(params, "Mobile");
        if (response.issuccess) {
            let data = response.data;
            if (data.length > 0) {
                formdata = data[0];
                if (formdata && formdata['Message'] !== undefined && formdata['Message'] !== null && formdata['Message'] !== "") {
                    formdata['Message'] = formdata['Message'].trimEnd();
                    const decodedHtml = decodeHtmlEntities(formdata['Message']);
                  //  const blocksFromHtml = htmlToDraft(decodedHtml);
                  //  const { contentBlocks, entityMap } = blocksFromHtml;
                    //const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                    //const state = EditorState.createWithContent(contentState);
                    //onEditorStateChange(state);
                    setTemplateContent(decodedHtml);
                }
                setFormData(formdata);
            }
        }
        return formdata;
    }

    const handleChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        formData[name] = value;
        setFormData(formData);
    }

    // const onEditorStateChange = (editorState) => {
    //     const stringmsg = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    //     setMsgString(stringmsg);
    //     const contentState = editorState.getCurrentContent();
    //     const plainText = contentState.getPlainText();
    //     let newPlainText = plainText.replace(/#\$/g, '$').replace(/#\[/g, '[').replace(/#\@/g, '@');
    //     if (!isHtmlView) {
    //         newPlainText = newPlainText.replace("&nbsp;", " ");
    //     }
    //     if (newPlainText !== plainText) {
    //      //   const newContentState = ContentState.createFromText(newPlainText);
    //       //  setEditorState(EditorState.push(editorState, newContentState));
    //     } else {
    //         setEditorState(editorState);
    //     }
    // };

    const toggleModal = () => {
        setMessageBoxRequired(false);
        toggleMainMadal();
    }

    const checkValidate = () => {
        return templateContent !== '';
    }

    const submitForm = async () => {
        let isValid = checkValidate();
        if (!isValid) {
            //setMessageBoxRequired(true);
            showToast("Template content cannot be empty", "", "error");
            return;
        } else {
            //setMessageBoxRequired(false);
        }
        let params = {
            "ENTITY": type == "sms" ? "SMSTEMPLATE_ENTITYNAME" : "EMAILTEMPLATE_ENTITYNAME",
            "FORMTYPE": type == "sms" ? "SMSTEMPLATE_ENTITYNAME" : "EMAILTEMPLATE_ENTITYNAME",
            "OPERATION": formid === "" ? "SAVE" : "EDIT",
            "FORMNAME": selectedForm.value,
            "name": formData['template_name'],
            "desc": formData['template_name'],
            "access": "1", //formData['access'].value,
        };
        
        let templateContentToSave = normalizeTemplateVariables(templateContent);
        let emailcontent = addTableBorder(templateContentToSave);//editor.getData();
        
        if (type === "sms") {
            params['type'] = 'Regular';
            params["t_id"] = formData['t_id'];
            params["channel"] = "SMS";
            params["imageurl"] = formData['imageurl'];
            let msgstring = replaceHtmlToString(emailcontent)
            params["content"] = msgstring === undefined && msgstring === "" ? formData['Message'] : msgstring;
        } else if (type === "email") {
            params['attachformdata'] = "0";
            params['address'] = "###";
            params['isdefault'] = "0";
            params['subject'] = formData["subject"];
           // let rawContentState = draftToHtml(convertToRaw(editorState.getCurrentContent()));
            if (isHtmlView) {
              //  rawContentState = decodeHtmlEntities(rawContentState)
            }
            params["content"] = emailcontent
        }
        if (formid != "") {
            params['id'] = formid;
        }
        let response = await requestApi.processServerRequest(params, "WebV2", "POST");
        if (response.issuccess) {
            toggleModal();
            await loadData();
            showToast(formid === "" ? "Created..." : "Updated...");
        }

    }

    const editorChange = async (name = "") => {
        if (name === "htmlview") {
            if (isHtmlView) {
                // HTML to Normal Text view
                const decodedhtml = decodeHtmlEntities(msgString);
                //onEditorStateChange(htmlToDraftBlocks(decodedhtml));
            } else {
                // Normal to HTML Code
                //const contentState = ContentState.createFromText(msgString);
               // const initialEditorState = EditorState.createWithContent(contentState);
               // onEditorStateChange(initialEditorState);
            }
            setIsHtmlView(!isHtmlView);
        } else {
            if (!isNormalEditor) {
                let goToNormal = await confirmBox("Warning", "Switching to 'Plain Editor' mode will make you lose all the formatting done. Are you sure you want to proceed?");
                if (goToNormal) {
                    setIsNormalEditor(!isNormalEditor);
                    setMsgString("");
                   // setEditorState(EditorState.createWithContent(ContentState.createFromText('')));
                }
            } else {
                setIsNormalEditor(!isNormalEditor);
            }
        }
    }

    const previewHtml = () => {
        setIsPreView(!isPreView);
    }

    const previewContainer = () => {
        let previewHtmlContant = msgString;

        if (isHtmlView) {
            previewHtmlContant = decodeHtmlEntities(msgString);
        }
        return (
            <div >
                <Modal isOpen={isPreView} size={'xl'} >
                    <ModalHeader toggle={previewHtml}>
                        {"Preview Template"}
                    </ModalHeader>
                    <ModalBody>
                        <div dangerouslySetInnerHTML={{ __html: previewHtmlContant }} />
                    </ModalBody>
                </Modal>
            </div>
        )
    };

    const saveTemplateInfo = async () => {
        await buttonClickRef.current.click();
    };

    let headerTxt = formid === "" ? "Create Template" : "Update Template";

    const handleOnChange = (name, value) => {
        if (name === "subject" && value.length >= 300) {
            showToast("Only 300 Characters", "", "warning");
            return;
        }
        formData[name] = value;
        setFormData({ ...formData });
    }
    const onCKEditorChange = async (content, editor) => {
        let emailcontent = editor.getData();
        setTemplateContent(emailcontent);
    }
    const getContanerModal = () => {
        const customButtons = [
            { name: "htmlview", title: isHtmlView ? "Rich Editor" : "HTML Code", label: !isHtmlView ? "<>" : "Rich Editor", handler: editorChange, classname: "rdw-option-wrapper", isDisabled: false, isView: true, mainClass: "custom-toolbar-container" },
            { name: "rich", title: "Plain Editor", label: !isNormalEditor ? "Plain Editor" : "Rich Editor", handler: editorChange, classname: "rdw-option-wrapper", isDisabled: false, isView: false, mainClass: "custom-toolbar-container" },
            { name: "preview", title: "Preview", label: "Preview", handler: previewHtml, classname: "rdw-option-wrapper", isDisabled: false, isView: false, mainClass: "custom-toolbar-container" },
        ]
        const customToolBarOption = [
            <CustomToolBarOption editorChange={editorChange} customButtons={customButtons} isHtmlView={isHtmlView} />
        ];

        let toolbar = {
            options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'history', 'image'],
        };
        toolbar['embedded'] = { className: "hide" }
        let mentionClassName = "form-input-templates textbox-mention" + (errors.subject ? " is-invalid " : "") + (type === "email" ? " width-temp-subject " : "");
        return (
            <div>
                <form onSubmit={handleSubmit(submitForm)}>
                    <div className={`content-box-container ${errors.template_name ? 'is-invalid' : ''}`}>
                        <div className="form-label form-label-template-label">
                            Template Name
                        </div>
                        <div className="form-field ">
                            <div className="form-field-wrapper">
                                <div className="field-input blur-item">
                                    <Controller
                                        name={'template_name'}
                                        control={control}
                                        rules={{ required: formData['template_name'] !== undefined && formData['template_name'] !== "" ? false : "Please choose Template Name" }}
                                        render={({ field }) => (
                                            <>
                                                <Input
                                                    type="text"
                                                    name="template_name"
                                                    id="template_name"
                                                    value={formData['template_name']}
                                                    autoComplete={"off"}
                                                    placeholder="Enter template name here"
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        field.onChange(e);
                                                    }}
                                                    className={`form-input-templates`}
                                                />
                                            </>
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                        {errors.template_name && <em className={`error invalid-feedback`}>{errors.template_name.message}</em>}
                    </div>
                    {
                        type === "email" &&
                        <div className={`content-box-container ${errors.subject ? 'is-invalid' : ''}`}>
                            <div className="form-label form-label-template-label">
                                Subject
                            </div>
                            <div>
                                <CratioMention
                                    name={"subject"}
                                    inputID={"subject"}
                                    value={formData["subject"]}
                                    fieldkey={"value"}
                                    type={type}
                                    mentionTrigger={"#"}
                                    handleOnChange={handleOnChange}
                                    formname={newSelectedForm.value}
                                    control={control}
                                    customClassName={mentionClassName}
                                    customPanelClassName={"panel-mention-subject"}
                                    placeholder={"Enter email subject here"}
                                    cols={100}
                                    rows={1}
                                />
                            </div>
                            {errors.subject && <em className={`error invalid-feedback`}>{errors.subject.message}</em>}
                        </div>
                    }
                    {
                        type === "sms" &&
                        <div className={"content-box-container"}>
                            <div className="form-label form-label-template-label  after-empty-val">
                                DLT TEMPLATE ID
                            </div>
                            <Controller
                                name={'t_id'}
                                control={control}
                                rules={{ required: formData['t_id'] === "" ? false : false }}
                                render={({ field }) => (
                                    <>
                                        <Input
                                            id={`t_id`}
                                            name={`t_id`}
                                            value={formData["t_id"]}
                                            onChange={e => {
                                                handleChange(e, "t_id");
                                                field.onChange(e);
                                            }}
                                            placeholder={"Enter DLT template id here"}
                                            className={`form-input-templates ${errors.template_name ? 'is-invalid' : ''}`}
                                        />
                                    </>
                                )} />
                        </div>
                    }

                    <div className={`${type === "sms" ? 'sms-editor-container' : 'email-editor-container'}`}>
                        {isHtmlView && customToolBarOption}
                        {/*
                        <Editor
                            wrapperClassName={cx({ "editor-error": messageBoxRequired })}
                            editorClassName={`quickreply-editor-wrapper email-sms-editor ${type === "email" ? "height-62vh" : "height-70vh"}`}
                            editorState={editorState}
                            onEditorStateChange={onEditorStateChange}
                            toolbar={toolbar}
                            toolbarCustomButtons={customToolBarOption}
                            toolbarHidden={type !== "email" || isHtmlView}
                            toolbarClassName={`toolbarClassName`}
                            
                            mention={
                                {
                                    separator: ' ',
                                    trigger: '#',
                                    suggestions: fieldsOption,
                                }
                            }
                        />*/}
                        { 
                            fieldsOption.length > 0 && 
                            <CKEditorComponent 
                                isMentionsNeeded={true} 
                                isNew={formid === ""} 
                                content={templateContent} 
                                mentionItems={fieldsOption} 
                                onEditorChange={onCKEditorChange} 
                                showToolbar={type !== "sms"}
                            />
                        }                        
                        <em className={cx(`error invalid-feedback editor-error-msg`, { 'hide': !messageBoxRequired })}>{"Please body"}</em>
                    </div>
                    <div className="footer-modal-container hide">
                        <span className="form-label form-label-template-label ml25 after-empty-val hint-label">
                            Note: Use # to insert variables.
                        </span>
                        <span className="hide">
                            <button ref={buttonClickRef} type="submit">
                                <span>Save</span>
                            </button>
                        </span>
                    </div>
                    <span className="hide">
                        <button ref={buttonClickRef} type="submit">
                            <span>Save</span>
                        </button>
                    </span>
                </form>
                <div>
                    {isPreView && previewContainer()}
                </div>
            </div>
        );
    }

    return (
        <div>
            <Modal
                isOpen={isMainModal}
                toggle={toggleMainMadal}
                className={'le-modal-lg template-editor-modal campaign-modal y-scroll-hidden'}>
                <ModalBody>
                    <CommonHeaderContent
                        headerTitle={headerTxt}
                        isModal={isMainModal}
                        badge={newSelectedForm}
                        closeModal={toggleMainMadal}
                        buttonTxt={headerTxt}
                        buttonAction={saveTemplateInfo}
                        buttonIcon={"pe-7s-diskette"}
                        prefix={type}
                        isClassNeeded={false}
                        mainContent={
                            getContanerModal()
                        }
                    />
                </ModalBody>
                <ModalFooter>
                    <div className="footer-modal-container">
                        <span className="form-label form-label-template-label after-empty-val hint-label">
                            Note: Use # to insert module variables, Use @ to use organization variables.
                        </span>
                    </div>
                </ModalFooter>
            </Modal>
        </div>
    )
}
export default TemplateOperation;